/** @format */

import { InjectionToken } from '@angular/core';
import type { Request, Response } from 'express-serve-static-core';

export const REQUEST = new InjectionToken<Request>('REQUEST');
export const RESPONSE = new InjectionToken<Response>('RESPONSE');
